module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }